import { forwardRef, type ReactNode, type HTMLAttributes } from 'react';
import { useTheme } from '@vitness/theme';

export interface EyebrowProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Eyebrow = forwardRef<HTMLDivElement, EyebrowProps>(function Eyebrow(
  { children, style, ...props },
  ref,
) {
  const { accentSafe } = useTheme();

  return (
    <div
      ref={ref}
      style={{
        fontFamily: 'var(--vn-font-mono)',
        fontSize: 10,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: accentSafe,
        marginBottom: 10,
        opacity: 0.85,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
});
